export default __webpack_public_path__ + "static/media/ao.a175e689.svg";